import type { DependencyContainer } from 'tsyringe'
import type { Pinia } from 'pinia'
import { DITokens } from '@/di'
import { GMOGatewayImpl } from '@/gateways/GMOGatewayImpl'
import { ElasticsearchGatewayImpl } from '@/gateways/ElasticsearchGatewayImpl'
import { useToastStore } from '@/store/toast'
import { useCartStore } from '@/store/cart'
import { useNavigationStore } from '@/store/navigation'
import { useOrderStore } from '@/store/order'
import { useProfileStore } from '@/store/profile'
import { usePokemonStore } from '@/store/pokemon'
import type { ProductTypeIds } from '@/gateways/ElasticsearchGatewayImpl'

interface Params {
  pinia: Pinia
  GMO_TOKEN_API_KEY: string
  TCG_PLATFORM_ES_ENDPOINT: string
  TCG_PLATFORM_ES_API_KEY: string
  // TODO: 一時的にシングル商品をセット商品などとして扱うことも許容する。セット商品などの対応後は不要となるので、削除する
  productTypeIds: ProductTypeIds
}

export const register = (container: DependencyContainer, params: Params) => {
  const { pinia, GMO_TOKEN_API_KEY, TCG_PLATFORM_ES_ENDPOINT, TCG_PLATFORM_ES_API_KEY, productTypeIds } = params

  // Gateway
  const elasticsearchGateway = new ElasticsearchGatewayImpl(TCG_PLATFORM_ES_ENDPOINT, TCG_PLATFORM_ES_API_KEY, productTypeIds)
  container.register(DITokens.GMOGateway, { useValue: new GMOGatewayImpl(GMO_TOKEN_API_KEY) })
  container.register(DITokens.ElasticsearchGateway, { useValue: elasticsearchGateway })

  // Store
  container.register(DITokens.CartStore, { useValue: useCartStore(pinia) })
  container.register(DITokens.NavigationStore, { useValue: useNavigationStore(pinia) })
  container.register(DITokens.OrderStore, { useValue: useOrderStore(pinia) })
  container.register(DITokens.ToastStore, { useValue: useToastStore(pinia) })
  container.register(DITokens.ProfileStore, { useValue: useProfileStore(pinia) })
  container.register(DITokens.PokemonStore, { useValue: usePokemonStore({ elasticsearchGateway })(pinia) })

  return container
}
